import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState({       
    reducer(val) { 
      return {
          user: val.user //只儲存使用者資料   
      }
    }
  })],
  state: {
    user:{
      admin: null,
      logged_in: false,
      user_level: 'USER',
      username: null,
      school_id: null,
      school_name: null,
      school_chi_name: null,
      auth_token: null,
    },
    current:{
      experiment:'',
      equipment_id: '',
      booking_id: null,
      end_at: null,
    },
    experiment_name_translation: {
      "interference": "Interference",
      "em_induction": "Electromagnetic Induction",
      "apparent_depth": "Apparent Depth",
    },
    experiments:{
      "interference":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/interference.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/interference.png"
      },
      "apparent_depth":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/apparent-depth.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/apparent-depth.png"
      },
      "em_induction":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/em-induction.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/em-induction.png"
      },
      "visible_spectrum":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/visible-spectrum.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/visible-spectrum.png"
      },      
      "emission_spectrum":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/emission-spectrum.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/emission-spectrum.png"
      },
      "green_house":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/green-house.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/green-house.png"
      },
      "bacteria_growth":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/bacteria-growth.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/bacteria-growth.png"
      },
      "photo_electric":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/photo-electric.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/photo-electric.png"
      },
      "radiation":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/radiation.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/radiation.png"
      },
      "titration":{
          "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/titration.pdf",
          "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/titration.png"
      },
      "ultrasound":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/ultrasound.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/ultrasound.png"
      },
      "respiration":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/respiration.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/respiration.png"
      },
      "photosynthesis":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/photosynthesis.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/photosynthesis.png"
      },
      "identify_unknown_anion":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/identify-unknown-anion.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/identify-unknown-anion.png"
      },
      "kinetic_rate":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/kinetic-rate.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/kinetic-rate.png"
      },
      "spectrophotometry":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/spectrophotometry.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/spectrophotometry.png"
      },
      "iodine_test":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/iodine-test.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/iodine-test.png"
      },
      "tensile_test":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/tensile-test.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/tensile-test.png"
      },
      "new_interference":{
        "labManual": "https://stem-ap.polyu.edu.hk/remotelab/assets/files/new_interference.pdf",
        "setupPhoto": "https://stem-ap.polyu.edu.hk/remotelab/assets/images/new_interference.png"
      },
    },
    snackbar:{
        modal: false,
        message:""
    }
  },
  actions: {
  },
  mutations: {
    updateUserInfo(state, {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token}){
      state.user.username = username;
      state.user.user_level = user_level;
      state.user.school_id = school_id;
      state.user.school_name = school_name;
      state.user.school_chi_name = school_chi_name;
      state.user.logged_in = logged_in;
      state.user.auth_token = auth_token;
    },
    updateCurrentExperiment(state, experiment){
      state.current.experiment = experiment;
    },
    showSnackBar(state, message) {
      state.snackbar.message = message;
      state.snackbar.modal = true;
    }
    
  },
  getters: {
    current: state => {
      return state.current;
    }
  }
})